export function formatRate(value: number, significantDigits = 3) {
  if (value === 0) return "0"

  return value.toPrecision(significantDigits)
}
